import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "../../app.state";
import { createAction } from "@ngrx/store";
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { DocumentService } from "src/app/shared/services/document.service";
import { loadFullList, loadFullListFailure, loadFullListSucess, rankChangeFull, rankFullChangeFail, rankFullChangeSuccess } from "./fullList.actions";
import { catchError, exhaustMap, from, map, Observable, of, switchMap, withLatestFrom } from "rxjs";
import { DownloadService } from "src/app/shared/services/download.service";
import { selectFullItemList } from "./fullList.selector";

// this._downloadService.downloadSuggestedOrder("_test-tag_").then(result => {
//     this.downloadedPdfs = result
//     this.loading = false
//     console.log("dd", this.downloadedPdfs)
//     console.log("dd", this.downloadedPdfs.length)

//   })

@Injectable()
export class fullListEffects{
    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private docService: DocumentService,
        private downloadService: DownloadService
    ){

    }



    rankListChangedFull$ = createEffect(() => {
        return this.actions$.pipe(
          ofType(rankChangeFull),
          withLatestFrom(this.store.select(selectFullItemList)),
          switchMap((info)=>{
            // console.log("info from rank FULL change", info)

            return from(this.docService.autoSaveRankFull(info[1])).pipe(
                map(()=>{
                    return rankFullChangeSuccess()
                }),catchError(err=>{
                    // console.log("error on quad", err)
                    return of(rankFullChangeFail())
                })
            )
          })
        )
    })

    // rankListChanged$ = createEffect(() => {
    //     return this.actions$.pipe(
    //       ofType(rankChange),
    //       withLatestFrom(this.store.select(selectSeoItemList)),
    //       switchMap((info)=>{
    //         return from(this.docService.autoSaveRank(info[1])).pipe(
    //             map(()=>{
    //                 return rankChangeSuccess()
    //             }),catchError(err=>of(rankChangeFail()))
    //         )
    //       })
    //     )
    // })

    // rankListChanged$ = createEffect(() =>
    //         this.actions$.pipe(
    //             ofType(loadSeoList),
    //             switchMap(()=>
    //                 {
    //                     return from(this.downloadService.autoSaveRank()).pipe(
    //                         map((list)=> {
    //                             console.log("Check list", list)
    //                             return rankChangeSuccess()
    //                         }),
    //                         catchError((error)=> of(loadSeoListFailure({error})))
    //                     )
    //                 }
    //             )
    //         )
    // )

    loadFullList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadFullList),
            switchMap((info)=>
                {
                    return from(this.downloadService.downloadFullList(info.user)).pipe(
                        map((list)=> {
                            let newOrder = []

                            list.sort(function(a:any, b:any){return a.rank - b.rank});
                            return loadFullListSucess({ fullList: list })
                        }),
                        catchError((error)=> of(loadFullListFailure({error})))
                    )
                    // return of(loadQuadListFailure({"error": 'dasf'}))
                }
            )
        )
    )

    
}